import { propOr } from 'rambda';

import { DEFAULT_ERROR_MESSAGE } from '../constants';

export const getErrorMessage = (
  error: { message?: string },
  message = DEFAULT_ERROR_MESSAGE,
): string => propOr(message, 'message', error);
